@if (form) {
  <form [formGroup]="form">
    <p-panel class="mb-4" header="Enter new Provider information">
      <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget">
        <div class="col-span-12 md:col-span-6">
          <div class="field">
            <label>First Name:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="firstName"trimInputValue />
            </div>
          </div>
          <div class="field">
            <label>Last Name:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="lastName" trimInputValue />
            </div>
          </div>
          <div class="field">
            <label>NPI:</label>
              <div class="p-field-value">
                <p-input-mask
                  slotChar=""
                  mask="9999999999"
                  [maxlength]="10"
                  formControlName="practiceNpinumber"
                  [autoClear]="false"
                  data-test-id="npi-value"
                ></p-input-mask>
              </div>
          </div>
        </div>
        <div class="col-span-12 md:col-span-6">
          <div class="field">
            <label>Street:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="physicalStreet" trimInputValue />
            </div>
          </div>
          <div class="field">
            <label>City:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="physicalCity" trimInputValue />
            </div>
          </div>
          <div class="field">
            <label>State:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="physicalState" trimInputValue />
            </div>
          </div>
          <div class="field">
            <label>ZIP Code:</label>
            <div class="p-field-value">
              <p-input-mask
                slotChar=""
                mask="99999"
                [maxlength]="5"
                formControlName="physicalZip"
                [autoClear]="false"
                data-test-id="zip-code-value"
              ></p-input-mask>
            </div>
          </div>
          <div class="field">
            <label>Phone:</label>
            <div class="p-field-value">
              <p-input-mask
                mask="(999) 999-9999"
                formControlName="phone"
                [unmask]="false"
                [autoClear]="false"
              ></p-input-mask>
            </div>
          </div>
        </div>
      </div>
    </p-panel>
  </form>
}
